import { render } from "./PageTaskCard.vue?vue&type=template&id=021433ba&scoped=true"
import script from "./PageTaskCard.vue?vue&type=script&lang=js"
export * from "./PageTaskCard.vue?vue&type=script&lang=js"

import "./PageTaskCard.vue?vue&type=style&index=0&id=021433ba&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021433ba"]])

export default __exports__